'use strict';

const Mn = require('backbone.marionette');
const DiagramActionCreator = require('system/domain/action/diagram');
const DiagramModel = require('system/domain/entity/diagram');
const MarkdownWriterView = require('common/ui/view/markdown/writer');
const Template = require('system/ui/template/modal/diagram-edit.hbs');

module.exports = Mn.View.extend({
    template: Template,
    modelEvents: {
        'destroy': 'remove',
        'change:name': 'uploadable',
        'change:type': 'uploadable',
        'change:description': 'uploadable'
    },
    bindings: {
        'input.name': 'name',
        'select.type': {
            observe: 'type',
            selectOptions: {
                collection: DiagramModel.types,
                labelPath: 'name',
                valuePath: 'type'
            }
        },
        '.diagram-icon': {
            observe: 'type',
            updateMethod: 'html',
            onGet: function(value) {
                return `<div class="icon diagram-type-${value}"></div>`;
            }
        },
        'input.description': 'description'
    },

    initialize: function() {
        this._original = this.model;
        this.model = this.model.clone();
        this.listenTo(this._original, 'destroy', this.destroy);
    },

    onRender: function() {
        // markdown writer
        const writer = new MarkdownWriterView({
            project: this.getOption('project'),
            markdown: this.model.get('description'),
            useDataContentSelector: true
        });
        this.$('.diagram-list-item-description').append(writer.render().$el);
        this.listenTo(writer, 'change', function(desc){
            this.model.set('description', desc);
        });

        this.stickit(this.model);
        return this;
    },

    uploadable: function () {
        if(this.model.get('name')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    save:  function() {
        return new Promise((resolve, reject) => {
            if(this.model.get('creating')) {
                DiagramActionCreator.createDiagram (
                    this.model.getProjectId(),
                    this.model.toJSON()
                )
                    .then(() => {
                        this._original.trigger('destroy', this._original);
                        resolve();
                    });
            } else {
                DiagramActionCreator.updateDiagram (
                    this.model.getProjectId(),
                    this.model.id,
                    this.model.toJSON()
                )
                    .then(() => {
                        this._original.set({edit: false});
                        resolve();
                    });
            }
        });
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/modal/diagram-edit.js